import React from "react";
import Navbar from '../navBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/md-dark-indigo/theme.css";
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css';
import 'react-slideshow-image/dist/styles.css'
import { useTranslation } from "react-i18next";
import FooterComponent from "../footer";
import "../../style/table.css"
import { Menu } from "primereact/menu";
import "../../style/commonMobile.css";
import TableRawQuartz from "../rawQuartzTable";
import QuartzMenu from "../quartzMenu";

const Quartz_Raw = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <PrimeReactProvider>
            <Navbar />
            <div className="feldspatContainer">
                <div style={{ display: "block" }}>
                    <QuartzMenu />
                </div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                    <TableRawQuartz baslik="TEKNOMADEN RAW QUARTZ TDS" plantAddress="Yeşilköy/Kavaklıdere/Muğla" kod="RAW QUARTZ" humidity="0.5" sio2="98.57" k2o="0.16" na2o="0.30" tio2="0.04" fe2o3="0.05" al2o3="0.50" mgo="0.03" cao="0.0001" kk="0.35" />
                </div>
            </div>
            <FooterComponent />
        </PrimeReactProvider>
    );
}
export default Quartz_Raw;